import React, { useEffect, useState } from "react";
import { CiCirclePlus } from "react-icons/ci";
import nodatafound from "../../../../../Assets/Icons/NoDataCard2.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchPatMappedRpmDevList,
  setSelectedRpmPatient,
} from "../../../../../Redux/actions/rpmActions";
import MappedDevicesTable from "./mappedDevicesTable";
import { Flex, Modal, Spin } from "antd";
import AddDevices from "./newDeviceMapping";
import DevicesFilter from "./devicesFilter";
import { FaFilter } from "react-icons/fa";

function Index() {
  const [currentPage, setCurrentPage] = useState(1);
  const [filterModal, setFilterModal] = useState(false);
  const [deviceFiltered, setDeviceFiltered] = useState(false);
  const { isLoading, mappedDevicesList, selectedRpmPatient } = useSelector(
    (state) => state.rpm
  );
  const [newDeviceMapMod, setNewDeviceMapMod] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    const payload = {
      patientCode: selectedRpmPatient.patientId,
      status: 1,
    };
    dispatch(fetchPatMappedRpmDevList(payload));
  }, []);

  useEffect(() => {
    if (!selectedRpmPatient) {
      const rpmPatientJson = localStorage.getItem("rpmPatient");
      const rpmPatientObject = rpmPatientJson
        ? JSON.parse(rpmPatientJson)
        : null;
      if (rpmPatientObject) dispatch(setSelectedRpmPatient(rpmPatientObject));
    }
  }, []);

  const handleNewDeviceMapping = () => {
    setNewDeviceMapMod(!newDeviceMapMod);
  };

  const handleFilterModal = () => {
    setFilterModal(true);
  };
  const handleCloseFilter = () => {
    setFilterModal(false);
  };

  const handleClearFilter = () => {
    const payload = {
      patientCode: selectedRpmPatient.patientId,
      status: 1,
    };
    dispatch(fetchPatMappedRpmDevList(payload));
    setDeviceFiltered(false);
  };

  return (
    <>
      <div>
        <div className="flex justify-between items-center py-3">
          <div className="">
            <h1 className="font-bold text-xl">Device Setup</h1>
          </div>
          <div className="flex gap-4">
            <div>
              <button
                onClick={handleNewDeviceMapping}
                className="w-20 h-8 px-2 flex bg-[#F1FFF9] items-center gap-2 border border-[#3B98B9] rounded-md"
              >
                <span className="w-5 h-5">
                  <CiCirclePlus className="w-full text-[#189FAA] h-full" />
                </span>
                <span className="">New</span>
              </button>
            </div>
            <div>
              <button
                onClick={handleFilterModal}
                className="w-20 h-8 px-2 flex items-center rounded-md gap-2 bg-brand-primaryColor"
              >
                <span>
                  <FaFilter className="mr-1 text-white" />
                </span>
                <span className="text-white"> Filter</span>
              </button>
              {deviceFiltered && (
                <p
                  className="py-2 px-2 flex items-center gap-2 text-brand-primaryColor cursor-pointer"
                  onClick={handleClearFilter}
                >
                  Clear All
                </p>
              )}
            </div>
          </div>
        </div>
        <div
          className={`${
            isLoading === false && mappedDevicesList?.length === 0
              ? "w-full flex justify-center items-center"
              : "overflow-y-scroll h-[23rem] border rounded-lg scrollWidth"
          }`}
        >
          {isLoading && mappedDevicesList?.length === 0 ? (
            <div className="flex items-center justify-center mt-[10%]">
              <Flex align="center" gap="middle">
                <Spin size="large" tip="Loading" />
              </Flex>
            </div>
          ) : mappedDevicesList?.length === 0 ? (
            <div className="flex flex-col items-center justify-center">
              <img src={nodatafound} alt="nodatafound" className="h-48 w-48" />
              <p className="font-medium">No data found!!</p>
            </div>
          ) : (
            <div>
              <MappedDevicesTable
                data={mappedDevicesList}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                totalCount={mappedDevicesList?.length}
              />
            </div>
          )}
        </div>
      </div>

      {/* New device mapping */}
      <Modal
        open={newDeviceMapMod}
        onCancel={handleNewDeviceMapping}
        footer={[]}
      >
        <AddDevices handleClose={handleNewDeviceMapping} />
      </Modal>

      {/* Filter */}
      <Modal
        title="Filter"
        open={filterModal}
        onCancel={handleCloseFilter}
        footer={[]}
        destroyOnClose
        width={"40%"}
      >
        <DevicesFilter
          handleClose={handleCloseFilter}
          selectedRpmPatient={selectedRpmPatient}
          setDeviceFiltered={setDeviceFiltered}
        />
      </Modal>
    </>
  );
}

export default Index;
